import { cloneDeep } from 'lodash';
import { createWhenBlockUpdater } from './createWhenBlockUpdater';
import { traverseAndTransformWhenBlocks } from './traverseAndTransformWhenBlocks';

/**
 * Prepares a local MeshBot block for saving by transforming its "when" blocks
 * into the API-required format.
 *
 * This function creates a deep clone of the provided selectedBlock to avoid mutating the original data,
 * then recursively traverses all "when" blocks and applies the appropriate transformation strategy
 * based on each block's node type.
 *
 * @param {Object} selectedBlock - The local MeshBot block selected for editing.
 * @param {Object} controllerData - Controller data required for block transformations.
 * @param {Array<Object>} controllerData.devices - List of devices associated with the controller.
 * @param {Array<Object>} controllerData.items - List of items associated with the controller.
 * @returns {Object} A new MeshBot block object prepared for API submission (immutable from the original).
 *
 * @example
 * const preparedBlock = transformLocalMeshBotForSave(selectedBlock, controllerData);
 * // Now preparedBlock is ready to be sent to the backend
 */
export const transformLocalMeshBotForSave = (selectedBlock, controllerData) => {
    const clonedSelectedBlock = cloneDeep(selectedBlock);
    const updateWhenBlock = createWhenBlockUpdater(controllerData);
    traverseAndTransformWhenBlocks(clonedSelectedBlock.when, updateWhenBlock);

    return clonedSelectedBlock;
};
